import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { SNETTextfield } from "shared/dist/components";
import MMAddress from "./MMAddress";

const TechnicalInfo = () => {
    const groups = useSelector((state) => state.organization.groups);

    return (
        <Fragment>
            <Typography variant="subtitle1">Technical Information</Typography>
            <MMAddress />
            {groups.map((group) => (
                <Fragment key={group.id}>
                    <SNETTextfield
                        disabled
                        label="Payment Address"
                        description="The ethereum address to which all the payments will be transferred "
                        name="paymentaddress"
                        value={group.paymentAddress}
                    />
                    {group.paymentConfig.paymentChannelStorageClient.endpoints.map((endpoint) => (
                        <SNETTextfield
                            disabled
                            label="ETCD Endpoint"
                            description=" ETCD end points that will be used for this organization."
                            name="etcdendpoints"
                            value={endpoint}
                            key={endpoint}
                        />
                    ))}
                </Fragment>
            ))}
        </Fragment>
    );
};

export default TechnicalInfo;
